import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { ARCHIVED_FORMS } from './archivedForms';
import { API_ORIGIN } from '../../config';

/** How many responses an archived form has (null when it can't be read). */
const countOf = async (form) => {
  try {
    const url = form.list.paged ? `${API_ORIGIN}${form.list.url}?limit=1` : `${API_ORIGIN}${form.list.url}`;
    const response = await fetch(url);
    if (!response.ok) return null;
    const data = await response.json();
    if (form.list.paged) return data.pagination?.total ?? null;
    return (data[form.list.key] || []).length;
  } catch {
    return null;
  }
};

/**
 * The retired hard-coded forms, below the dynamic forms on the client admin page. Their responses
 * open in a read-only archive view.
 */
const OlderForms = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    let live = true;
    ARCHIVED_FORMS.forEach(async (form) => {
      const n = await countOf(form);
      if (live) setCounts((c) => ({ ...c, [form.key]: n }));
    });
    return () => { live = false; };
  }, []);

  return (
    <section className="ca-older" aria-labelledby="ca-older-title">
      <header className="ca-older__head">
        <h3 className="ca-older__title" id="ca-older-title">Older forms</h3>
        <p className="ca-sub">Closed forms from before dynamic forms. Their responses can be looked up and exported, not changed.</p>
      </header>
      <ul className="ca-list">
        {ARCHIVED_FORMS.map((f) => (
          <li key={f.key} className="ca-row is-closed">
            <span className="ca-row__main">
              <span className="ca-row__name">{f.name}</span>
              <span className="ca-row__meta">{f.what}</span>
            </span>
            <span className="ca-status is-closed">Closed</span>
            <span className="ca-row__count">
              <strong className="num">{counts[f.key] == null ? '–' : counts[f.key].toLocaleString()}</strong>
              <small>{counts[f.key] === 1 ? 'response' : 'responses'}</small>
            </span>
            <span className="ca-row__action">
              <Button icon={<InboxOutlined aria-hidden="true" />} onClick={() => navigate(`/client-admin/archive/${f.key}`)}>
                View responses
              </Button>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default OlderForms;
